export class CommonRequestError extends Error {
    response;
    url;
    statusCode;
    code;
    /** @deprecated use {@link response} instead */
    responseText;
    constructor(message, options = {}) {
        super(message);
        this.code = options.code;
        this.response = options.response;
        this.responseText = options.responseText;
        this.statusCode = options.statusCode;
        this.url = options.url;
    }
}
export function createRequestErrorFromResponse(response, url) {
    const body = response.body;
    return new CommonRequestError('HTTP Response Error', {
        statusCode: response.status,
        code: body && (body.errorCode || body.errorcode || body.code),
        response,
        responseText: body || response.responseText,
        url,
    });
}
//# sourceMappingURL=common-errors.js.map